import React, {useState} from 'react'
import {GlobalStyle, ImgCont, Wrapper} from './styles'
import Header from './components/Header'
import Footer from './components/Footer'
import ImgBox from './components/ImgBox'
import ColorPicker from './components/ColorPicker'

// prettier-ignore
const matrix = [
  [0,0], [1,0], [2,0],
  [0,1], [1,1], [2,1],
  [0,2], [1,2], [2,2],
  [0,3], [1,3], [2,3],
]
// const matrix = [
//   [0,0], [1,0], [2,0], [3,0], [4,0], [5,0],
//   [0,1], [1,1], [2,1], [3,1], [4,1], [5,1],
//   [0,2], [1,2], [2,2], [3,2], [4,2], [5,2],
//   [0,3], [1,3], [2,3], [3,3], [4,3], [5,3],
//   [0,4], [1,4], [2,4], [3,4], [4,4], [5,4],
//   [0,5], [1,5], [2,5], [3,5], [4,5], [5,5],
//   [0,6], [1,6], [2,6], [3,6], [4,6], [5,6],
//   [0,7], [1,7], [2,7], [3,7], [4,7], [5,7],
// ]

const App = () => {
  const [distance, setDistance] = useState(1)

  const easing = (num) => Math.pow(num, 3)

  const calculateDistance = ([x, y]) => {
    const center = [window.innerWidth / 4, window.innerHeight / 2]
    const maxHypot = Math.hypot(center[0], center[1])
    const hypot = Math.hypot(center[0] - x, center[1] - y)
    const distance = hypot / maxHypot
    const easeDistance = easing(distance)
    setDistance(easeDistance)
  }

  const handleMove = ({clientX, clientY}) => {
    calculateDistance([clientX, clientY])
  }

  const handleTouchMove = ({touches}) => {
    calculateDistance([touches[0].clientX, touches[0].clientY])
  }

  const [bgColor, setBgColor] = useState('#ebafab')
  const [textColor, setTextColor] = useState('#603337')

  return (
    <>
      <GlobalStyle />
      <Header textColor={textColor} />
      <Footer textColor={textColor} />
      {/* <ColorPicker
        bgColor={bgColor}
        setBgColor={setBgColor}
        textColor={textColor}
        setTextColor={setTextColor}
      /> */}

      <Wrapper
        onMouseMove={handleMove}
        onTouchMove={handleTouchMove}
        $color={bgColor}
      >
        <ImgCont $isTogether={distance < 0.001}>
          {matrix.map(([x, y], index) => (
            <ImgBox key={index} x={x} y={y} percent={distance} />
          ))}
        </ImgCont>
      </Wrapper>
    </>
  )
}

export default App
